/**
 * An order's one customer-facing reference is its stored order number, shown
 * whole: `ORD-02461247` for orders from 2026-09-19 on, and the longer numbers
 * issued before that (up to 41 characters) exactly as issued. Never an order
 * UUID, and never a shortened or derived form: those match nothing support or
 * search can find. The server guarantees every order a number.
 */

/** The number, trimmed, or null when there is none. */
export function orderNumberOf(orderNumber: string | null | undefined): string | null {
  const trimmed = typeof orderNumber === 'string' ? orderNumber.trim() : ''
  return trimmed || null
}

/** Inline mention: "Order ORD-02461247". No "#": the prefix already says what it is. */
export function orderLabel(orderNumber: string | null | undefined): string | null {
  const n = orderNumberOf(orderNumber)
  return n ? `Order ${n}` : null
}
